import styled from 'styled-components'
import { margin, MarginProps, WidthProps } from 'styled-system'
import themeGet from '@styled-system/theme-get'

export type ContainerProps = WidthProps

export const Container = styled.div<ContainerProps>`
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  justify-content: space-between;
  width: 100%;
`

export const CompoundRow = styled.div`
  display: flex;
  gap: ${themeGet('space.3')}px;
  color: ${themeGet('colors.text.secondary')};

  > svg {
    width: 16px;
    height: 16px;
  }
`

export const ImageContainer = styled.div<MarginProps>`
  display: flex;
  width: 100%;
  height: auto;

  > img {
    max-width: 100%;
    max-height: 300px;
    object-fit: cover;
    height: auto;
    border-radius: 8px;
  }

  ${margin}
`
